import React, { useState } from 'react';
import { useMsal, useAccount, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './authConfig';
import './App.css';
import Chat from './pages/Chat';
import BotChat from './pages/BotChat';
import Dashboard from './pages/Dashboard';
import MyHistory from './pages/MyHistory';

const NAV_ITEMS = [
    {
        section: '',
        items: [
            { id: 'dashboard', label: 'Home', icon: '🏠', available: true },
            { id: 'assistant', label: 'AI Assistant', icon: '💬', available: true },
        ]
    },
    {
        section: 'Knowledge',
        items: [
            { id: 'bots', label: 'Knowledge Bots', icon: '🤖', available: true },
        ]
    },
    {
        section: 'My Account',
        items: [
            { id: 'history', label: 'Assistant History', icon: '🕐', available: true },
        ]
    }
];

function PortalContent() {
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    const [activePage, setActivePage] = useState('dashboard');
    const [navState, setNavState] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = () => instance.logoutRedirect();

    const userName = account?.idTokenClaims?.preferred_username
        || account?.idTokenClaims?.email
        || account?.username
        || 'User';

    const initials = userName.charAt(0).toUpperCase();

    const handleNavigate = (page, state = null) => {
        setNavState(state);
        setActivePage(page);
        setSidebarOpen(false);
    };

    const renderPage = () => {
        switch (activePage) {
            case 'dashboard': return <Dashboard onNavigate={handleNavigate} />;
            case 'assistant': return <Chat navState={navState} onNavigate={handleNavigate} />;
            case 'bots': return <BotChat />;
            case 'history': return <MyHistory onNavigate={handleNavigate} />;
            default: return <ComingSoon />;
        }
    };

    return (
        <div className="portal-layout">

            <div className="mobile-topbar">
                <button
                    className="mobile-hamburger"
                    onClick={() => setSidebarOpen(true)}
                    aria-label="Open menu"
                >
                    ☰
                </button>
                <div className="mobile-topbar-brand-text">Hale Partnership</div>
                <div style={{ width: 32 }} />
            </div>

            <div
                className={`sidebar-backdrop ${sidebarOpen ? 'visible' : ''}`}
                onClick={() => setSidebarOpen(false)}
            />

            <aside
                className={`sidebar ${sidebarOpen ? 'expanded' : ''}`}
                onMouseEnter={() => {
                    if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                        setSidebarOpen(true);
                    }
                }}
                onMouseLeave={() => {
                    if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                        setSidebarOpen(false);
                    }
                }}
            >
                <div className="sidebar-brand">
                    <div className="sidebar-brand-text">Hale Partnership</div>
                    <div className="sidebar-subtitle">AI Workspace</div>
                </div>
                <nav className="sidebar-nav">
                    {NAV_ITEMS.map(section => (
                        <div key={section.section}>
                            {section.section && (
                                <div className="nav-section-label">{section.section}</div>
                            )}
                            {section.items.map(item => (
                                <button
                                    key={item.id}
                                    className={`nav-item ${activePage === item.id ? 'active' : ''}`}
                                    onClick={() => item.available && handleNavigate(item.id)}
                                    disabled={!item.available}
                                    title={item.label}
                                >
                                    <span className="nav-item-icon">{item.icon}</span>
                                    <span className="nav-item-label">{item.label}</span>
                                    {!item.available && (
                                        <span className="nav-item-coming">Soon</span>
                                    )}
                                </button>
                            ))}
                        </div>
                    ))}
                </nav>
                <div className="sidebar-footer">
                    <div className="sidebar-user">
                        <div className="sidebar-user-avatar">{initials}</div>
                        <div className="sidebar-user-name">{userName}</div>
                    </div>
                    <div className="sidebar-footer-actions">
                        <div style={{ marginTop: '0.5rem' }}>
                            <button
                                onClick={handleLogout}
                                style={{
                                    background: 'none',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    color: 'rgba(255,255,255,0.6)',
                                    padding: '0.25rem 0.75rem',
                                    borderRadius: '4px',
                                    fontSize: '0.72rem',
                                    cursor: 'pointer',
                                    width: '100%'
                                }}
                            >
                                Sign Out
                            </button>
                        </div>
                        <div style={{ fontSize: '0.7rem', opacity: 0.5, marginTop: '0.4rem' }}>
                            Hale Partnership
                        </div>
                    </div>
                </div>
            </aside>

            <main className="portal-main">
                {renderPage()}
            </main>
        </div>
    );
}

function ComingSoon() {
    return (
        <div className="coming-soon">
            <div className="coming-soon-icon">🚧</div>
            <h2>Coming Soon</h2>
            <p>This feature is currently in development and will be available in a future release.</p>
        </div>
    );
}

function App() {
    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={{ ...loginRequest }}
            loadingComponent={() => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '1.2rem', color: '#1a3a5c' }}>
                    Authenticating...
                </div>
            )}
            errorComponent={() => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '1.2rem', color: '#dc3545' }}>
                    Authentication failed. Contact your administrator.
                </div>
            )}
        >
            <PortalContent />
        </MsalAuthenticationTemplate>
    );
}

export default App;